import Vue from 'vue';
import { Cropper } from 'vue-advanced-cropper';

Vue.component('cropper', Cropper);
